angular.module('language', ['core', 'ui.router'])
    .factory('Language', function ($resource, $filter) {
        let Language = $resource('/crm/api/language/:id', {}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/language/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
        Language.getActive = () => Language.query({isActive: true}).$promise;
        return Language;
    })
    .service('localeService', function ($translate, $cookies) {
        this.getLanguage = () => {
            let locale = $cookies.get("org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE");
            if (angular.isDefined(locale)) {
                return locale;
            } else {
                return $translate.use();
            }
        };

        this.setLanguage = locale => {
            $cookies.put("org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE", locale);
            $translate.use(locale);
            moment.locale(locale);
        };

        this.autoconfigureLocale = function () {
            let locale = $cookies.get("org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE");
            if (angular.isDefined(locale)) {
                this.setLanguage(locale)
            } else {
                moment.locale('pl_PL');
                $translate.use("pl_PL");
            }
        };
    })
    .filter('localized', function (localeService) {
        return function (input) {
            let lang = localeService.getLanguage();
            if (input != null && input.map != null && !angular.isUndefined(input.map[lang])) {
                return input.map[lang];
            } else {
                return "";
            }
        };
    })
    .filter('localizedWithLang', function () {
        return function (input, lang) {
            if (input != null && input.map != null && !angular.isUndefined(input.map[lang])) {
                return input.map[lang];
            } else {
                return "";
            }
        };
    })
    .service('LanguageService', function ($rootScope, toastr, modals, Language) {
        this.edit = id => Language.get({id: id}, entity => this.editModal(entity));
        this.editModal = entity => {
            return modals.open('app/language/edit-modal.html', 'LanguageDialogController', entity, {size: 'sm'}, '$ctrl');
        };
        this.addModal = () => {
            let entity = new Language({
                active: true,
                id: null
            });
            return this.editModal(entity);
        };
        this.remove = item => {
            let content = `Czy chcesz usunąć język ${item.name}? Wszystkie tłumaczenia w tym języku zostaną usunięte z bazy danych bezpowrotnie`;
            return modals.confirm(content, () => Language.delete({id: item.id}, () => $rootScope.$broadcast('language.updated')).$promise);
        };
    })
    .component('languageList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/language/list.html',
        controller: function ($scope, $state, $stateParams, Language, LanguageService) {
            this.LanguageService = LanguageService;
            this.reset = () => this.filters = {}
            $scope.$on('language.updated', () => $state.reload());
        }
    })
    .controller('LanguageDialogController', function ($rootScope, $uibModalInstance, data, toastr, Language) {
        this.item = data;

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Language.update(this.item).$promise;
            } else {
                promise = Language.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('language.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            });
        };
    })
    .config(function ($stateProvider, $translateProvider) {
        $stateProvider.state('languageList', {
            parent: 'app',
            url: '/language?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "languageList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Language, $stateParams) => Language.table(angular.copy($stateParams)).$promise
            }
        });

        $translateProvider.uniformLanguageTag('java');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.useUrlLoader("/crm/api/messagebundle", {queryParameter: "language"});
    })
    .run(function (localeService) {
        localeService.autoconfigureLocale();
    });
